import { useSettingsQuery } from 'src/api/queries/userQueries';
import {
  AdminSettingsSection,
  Input,
  PageBody,
  SaveChangesBar,
  SettingsNavigation,
} from 'src/components';
import styles from './styles.module.scss';
import { useAtom } from 'jotai';
import { useMemo } from 'react';
import ReactSwitch from 'react-switch';
import { databaseSettingsAtom } from 'src/shared/settings/database';
import { addonsSettingsAtom } from 'src/shared/settings/addons';
import { PlanUpgradeBanner } from 'src/components/FeatureUnavailable/PlanUpgradeBanner';
import { ACTION_TYPES } from 'src/shared/settings/base';

export const DatabaseSettings = () => {
  const { isLoading } = useSettingsQuery();

  const [databaseSettings, updateDatabaseSettings] = useAtom(databaseSettingsAtom);
  const [addons] = useAtom(addonsSettingsAtom);
  // Database export is a SCALE/Enterprise entitlement (plan-structure v2).
  const dbExportGated = !(addons?.DATABASE_EXPORT?.added && addons?.DATABASE_EXPORT?.enabled);

  const events = useMemo(() => {
    if (!databaseSettings) return [];

    return Object.entries(databaseSettings.db_export_events).map(([key, value]: [string, any]) => ({
      key,
      enabled: value,
    }));
  }, [databaseSettings]);

  if (isLoading) {
    return null;
  }

  return (
    <div className={styles.pageWrapper}>
      <SettingsNavigation />
      <SaveChangesBar />

      <PageBody narrow>
        {dbExportGated && (
          <PlanUpgradeBanner
            gate={{ feature: 'database_export', requiredPlan: 'SCALE' }}
          />
        )}
        <AdminSettingsSection title="Database">
          <Input
            variant="secondary"
            value={databaseSettings.db_url}
            onChange={(value: string) =>
              updateDatabaseSettings({ type: ACTION_TYPES.UPDATE_STATE, payload: { db_url: value } })
            }
            placeholder=""
          />
          <p className={styles.sectionDescription}>
            Database URL for data export. Only MySQL database is supported.
          </p>
        </AdminSettingsSection>
        <AdminSettingsSection title="Asset events">
          <p className={styles.sectionDescription}>
            For Database Export, all events are enabled by default
          </p>
          <div className={styles.eventList}>
            {events.map(({ key }) => (
              <div key={key} className={styles.eventRow}>
                <ReactSwitch
                  checked={true}
                  onChange={() => {}}
                  checkedIcon={false}
                  uncheckedIcon={false}
                  onColor="#2e53e3"
                  disabled
                />
                <label>{key}</label>
              </div>
            ))}
          </div>
        </AdminSettingsSection>
      </PageBody>
    </div>
  );
};
